export const FETCH_CONTRACT_NOTES = 'FETCH_CONTRACT_NOTES';
export const FETCH_CONTRACT_NOTES_SUCCESS = 'FETCH_CONTRACT_NOTES_SUCCESS';
export const FETCH_CONTRACT_NOTES_FAILURE = 'FETCH_CONTRACT_NOTES_FAILURE';
export const FETCH_CONTRACT_NOTES_CANCEL = 'FETCH_CONTRACT_NOTES_CANCEL';

export const RESET_CONTRACT_NOTES = 'RESET_CONTRACT_NOTES';
